<div class="container">
  <mat-card>
    <h2 mat-title *ngIf="transactionType.ingreso">Ingreso vario</h2>
    <h2 mat-title *ngIf="transactionType.egreso">Egreso vario</h2>

  </mat-card>
  <div>
    <mat-card>
      <form [formGroup]="IngresoEgresoTransactionForm">
        <mat-card-content fxLayout="column">
          <mat-form-field>
            <mat-label>Moneda de transacción</mat-label>
            <mat-select formControlName="currencyCode" required (selectionChange)="selectCurrencyEvent()">
              <mat-option *ngFor="let curr of currencyOptions.selectedCurrencyOptions" [value]="curr.code">
                ({{ curr.code }}) {{ curr.displayLabel }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="IngresoEgresoTransactionForm.controls.currencyCode.hasError('required')">
              Moneda de transacción es <strong>obligatoria</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Monto</mat-label>
            <input type="text" mifosxNumberFormatDirective formControlName="transactionAmount" required matInput />
            <mat-error *ngIf="IngresoEgresoTransactionForm.controls.transactionAmount.hasError('required')">
              Monto es <strong>obligatorio</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field *ngIf="ingresoEgresoTemplate">
            <mat-label>Tipo de pago</mat-label>
            <mat-select formControlName="paymentTypeId" (selectionChange)="checkForEnableCheckOption()"
            [disabled]="isDisabledPaymentType"  required>
              <mat-option *ngFor="let paymentType of ingresoEgresoTemplate.paymentTypeOptions" [value]="paymentType.id">
                {{ paymentType.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="IngresoEgresoTransactionForm.controls.paymentTypeId.hasError('required')">
              Tipo de pago es <strong>obligatorio</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field *ngIf="causesOptions">
            <mat-label>Causal</mat-label>
            <mat-select formControlName="paymentCauseId" required>
              <ng-container *ngFor="let cause of causesOptions">
                <mat-option [value]="cause.id">
                  {{ cause.description }}
                </mat-option>
              </ng-container>
            </mat-select>
            <mat-error *ngIf="IngresoEgresoTransactionForm.controls.paymentCauseId.hasError('required')">
              Causal es <strong>obligatorio</strong>
            </mat-error>
          </mat-form-field>

          <div id="check-grouping" fxLayoutGap="5px" fxLayout="row" fxLayout.xs="column" *ngIf="showCheckDetailsView">
            <mat-label fxFlexAlign="center" style="width: 30%;">Mostrar detalles de cheque</mat-label>
            <button type="button" mat-mini-fab color="primary" (click)="addCheckDetails()" fxFlexAlign="right">
              <fa-icon [icon]="!addCheckDetailsFlag ? 'plus-circle' : 'minus-circle'" size="lg"></fa-icon>
            </button>
          </div>

        </mat-card-content>
      </form>

      <form [formGroup]="checkForm">
        <mat-card-content fxLayout="column">
          <mat-form-field *ngIf="checkForm.controls['chequeCountry']">
            <mat-label>País</mat-label>
            <mat-select formControlName="chequeCountry" required [disabled]="true">
              <mat-option *ngFor="let country of ingresoEgresoTemplate.countryOptions" [value]="country.id">
                {{ country.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="checkForm.controls.chequeCountry.hasError('required')">
              País es <strong>obligatorio</strong>
            </mat-error>
          </mat-form-field>


          <mat-form-field *ngIf="checkForm.controls['chequeBank']">
            <mat-label>Banco</mat-label>
            <mat-select formControlName="chequeBank" required>
              <mat-option *ngFor="let bank of ingresoEgresoTemplate.bankOptions" [value]="bank.id">
                {{ bank.description }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="checkForm.controls.chequeBank.hasError('required')">
              Banco es <strong>obligatorio</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field *ngIf="checkForm.controls['chequeBank']">
            <mat-label>Moneda</mat-label>
            <input type="text" matInput value="{{IngresoEgresoTransactionForm.controls['currencyCode'].value }}"
              readonly />
          </mat-form-field>

          <mat-form-field *ngIf="checkForm.controls['checkAccountNumber']">
            <mat-label>No. Cuenta cheque</mat-label>
            <input type="text" mifosxNumberFormatDirective formControlName="checkAccountNumber" required matInput />
            <mat-error *ngIf="checkForm.controls.checkAccountNumber.hasError('required')">
              No. Cuenta cheque es <strong>obligatorio</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field *ngIf="checkForm.controls['chequeNumber']">
            <mat-label>No. Cheque</mat-label>
            <input type="text" mifosxNumberFormatDirective formControlName="chequeNumber" required matInput />
            <mat-error *ngIf="checkForm.controls.chequeNumber.hasError('required')">
              No. Cheque es <strong>obligatorio</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field *ngIf="checkForm.controls['checkSecurityNumber']">
            <mat-label>No. Seguridad</mat-label>
            <input type="text" mifosxNumberFormatDirective formControlName="checkSecurityNumber" matInput />
          </mat-form-field>

          <mat-form-field *ngIf="checkForm.controls['checkAmount']">
            <mat-label>Monto cheque</mat-label>
            <input formControlName="checkAmount" matInput />
          </mat-form-field>


          <mat-form-field *ngIf="checkForm.controls['targetName']">
            <mat-label>Nombre beneficiario</mat-label>
            <input formControlName="targetName" matInput />
          </mat-form-field>

          <mat-card-actions *ngIf="checkForm.controls['chequeNumber']" fxLayoutGap="5px" fxLayout="row"
            fxLayout.xs="column" fxLayoutAlign="center">
            <button type="button" mat-raised-button color="secondary" [disabled]="!checkForm.valid"
              (click)="addNewCheck()">Añadir cheque</button>
          </mat-card-actions>

          <table mat-table [dataSource]="checkDetailsTable" *ngIf="checkForm.controls['chequeNumber']">
            <caption>Tabla de cheques</caption>
            <ng-container matColumnDef="checkNumber">
              <th mat-header-cell *matHeaderCellDef> No. Cheque </th>
              <td mat-cell *matCellDef="let element"> {{element.checkNumber}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="checkAmount">
              <th mat-header-cell *matHeaderCellDef> Monto Cheque </th>
              <td mat-cell *matCellDef="let element"> {{element.checkAmount | currency: ' '}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef> Acción </th>
              <td mat-cell *matCellDef="let element">
                <button mat-button (click)="removeCheck(element.id)" color="primary">
                  <fa-icon icon="minus-circle"></fa-icon>&nbsp;&nbsp;Remove
                </button>
              </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="['checkNumber','checkAmount','id']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['checkNumber','checkAmount','id'];"></tr>

          </table>
        </mat-card-content>
      </form>

      <form [formGroup]="IngresoEgresoTransactionForm" (ngSubmit)="submit()">
        <mat-card-content fxLayout="column">
          <mat-form-field>
            <mat-label>Nota</mat-label>
            <textarea formControlName="note" matInput></textarea>
          </mat-form-field>


          <mat-card-actions fxLayoutGap="5px" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center">
            <button type="button" mat-raised-button [routerLink]="['../../']">Cancelar</button>
            <button mat-raised-button  [disabled]="isDisabled"  mat-button color="primary" >{{labelButton}}</button>
          </mat-card-actions>
        </mat-card-content>
      </form>

    </mat-card>
  </div>
</div>